import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import { getAllAnswers } from '../../../utils/onboardingStorage'

export default function MoodImpactInsightPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  // Get the mood impact rating from previous answer
  const allAnswers = getAllAnswers()
  const moodAnswer = allAnswers.moodScale
  const moodRating = moodAnswer?.answer_key || '3'

  // Determine if it's low impact (1-2) or high impact (3-5)
  const isLowImpact = parseInt(moodRating) <= 2

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="💡"
      heading={t(
        isLowImpact
          ? 'pages.onboarding.moodImpactInsight.lowImpact.heading'
          : 'pages.onboarding.moodImpactInsight.highImpact.heading',
      )}
      text={t(
        isLowImpact
          ? 'pages.onboarding.moodImpactInsight.lowImpact.description'
          : 'pages.onboarding.moodImpactInsight.highImpact.description',
      )}
      onSubmit={handleSubmit}
    />
  )
}
